// Versão REDUZIDA de uma foto pública, feita "na hora" pelo Photon (i0.wp.com, o CDN de imagens
// gratuito do WordPress.com — o mesmo que o painel antigo usava na frente do cdnpainel). O
// navegador baixa a foto já pequena (ex.: 1280 px de largura, ~90 KB) em vez do original de
// vários MB. Só funciona com URL pública (https e domínio real); em qualquer outro caso devolve a
// própria URL. Se o Photon falhar, use `aoErroImagem` pra voltar ao original.
export function urlOtimizada(url, largura, { qualidade = 92, quadrada = false } = {}) {
  if (!url) return url;
  let u;
  try {
    u = new URL(url);
  } catch {
    return url;
  }
  if (u.protocol !== 'https:' || u.hostname === 'localhost' || u.hostname.endsWith('.local')) return url;
  const alvo = quadrada ? `resize=${largura},${largura}&quality=${qualidade}` : `w=${largura}&quality=${qualidade}`;
  return `https://i0.wp.com/${u.host}${u.pathname}?${alvo}`;
}

// onError do <img>: volta pra foto original UMA vez (evita laço se o original também falhar)
export function aoErroImagem(originalUrl) {
  return (e) => {
    const img = e.currentTarget;
    if (img.dataset.voltou === '1') return;
    img.dataset.voltou = '1';
    img.src = originalUrl;
  };
}
